<calao-form-sectors-list *ngIf="!params.readOnly || (fieldValue?.length > 0)" [params]="params" [sectors]="fieldValue"
	(onSectorsChanged)="onSectorsChanged($event)">
</calao-form-sectors-list>